import { render, staticRenderFns } from "./EmployeeProjectsLabels.vue?vue&type=template&id=20ae0354"
import script from "./EmployeeProjectsLabels.vue?vue&type=script&lang=js"
export * from "./EmployeeProjectsLabels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports